module.exports = __webpack_public_path__ + "static/media/3.3d19415a.ogg";